"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundingString = exports.LAT_LNG_PRECISION = exports.BASE_ZOOM_LEVEL = void 0;
exports.BASE_ZOOM_LEVEL = 15;
exports.LAT_LNG_PRECISION = 7;
exports.BoundingString = {
    toString(center, zoom) {
        var currentZoom = zoom || exports.BASE_ZOOM_LEVEL;
        if (center == null) {
            return ``;
        }
        return `@${center.lat.toFixed(exports.LAT_LNG_PRECISION)},${center.lng.toFixed(exports.LAT_LNG_PRECISION)},${currentZoom.toFixed(0)}z`;
    },
    fromString(str) {
        if (typeof str !== 'string') {
            return null;
        }
        if (str.length < 2 || str.charAt(0) !== '@' || str.charAt(str.length - 1) !== 'z') {
            return null;
        }
        var chunks = str.substr(1, str.length - 2).split(',').map(val => parseFloat(val));
        var [lat, lng, zoom] = chunks;
        if (isNaN(lat) || isNaN(lng) || isNaN(zoom)) {
            return null;
        }
        if (lat === 0 || lng === 0 || zoom === 0) {
            return null;
        }
        return { lat, lng, zoom };
    }
};
//# sourceMappingURL=bounding.string.js.map